















import {defineComponent, PropType} from "@vue/composition-api";
import {ProjectEntityInterface, ShorturlEntityInterface} from "@tool/tool.types";
import ProjectReportsLayout from "@tool/Pages/App/Project/Reports/layout/ProjectReportsLayout.vue";
import {DateRangeInterface, ProjectReportSingleFilterInterface} from "@tool/Pages/App/Project/Reports/reports.types";
import {ResourceCollectionInterface} from "@base/base.types";
import useInertiaTable from "@tool/Helpers/useInertiaTable";
import ThemeBlock from "@base/Components/theme/ThemeBlock.vue";
import InertiaDatatable from "@base/Components/InertiaDatatable.vue";
import CopyInputGroup from "@base/Components/CopyInputGroup.vue";

export default defineComponent({
    components: {
        ProjectReportsLayout,
        ThemeBlock,
        InertiaDatatable,
        CopyInputGroup
    },
    props: {
        project: {
            type: Object as PropType<ProjectEntityInterface>,
            required: true
        },
        dateRange: {
            type: Object as PropType<DateRangeInterface<string>>,
            required: true
        },
        filters: {
            type: Array as PropType<ProjectReportSingleFilterInterface<any>[]>,
            required: true
        },
        shorturls: {
            type: Object as PropType<ResourceCollectionInterface<ShorturlEntityInterface>>,
            required: true
        }
    },
    setup(props) {
        const table = useInertiaTable(props.shorturls, [
            {
                key: 'full_url',
                label: 'Full UTM Url'
            },
            {
                key: 'shorturl',
                label: 'Short Url'
            },
            {
                key: 'clicks',
                label: 'Lifetime Clicks'
            },
            {
                key: 'clicks_period',
                label: 'Clicks'
            },
            {
                key: 'actions',
                label: 'Actions',
                class: 'actions'
            },
        ]);

        return {
            table,
        };
    }

})
